import attViewerVideoView from './attViewerVideoComponent.html';
import './attViewerVideoComponent.css';
import { VideoPlayerHtml5 } from 'components/sharpr/videoPlayer/html5/VideoPlayerHtml5.js';

export function attViewerVideoComponent() {
	return {
		bindings: {
			attachment: '<',
			searchTerm: '<?',
		},
		controllerAs: 'vm',
		controller: attViewerVideoComponentCtrl,
		template: attViewerVideoView,
	};
}

export class attViewerVideoComponentCtrl {
	constructor(Api, $element, modal, UrlData) {
		'ngInject';
		this.Api = Api;
		this.$element = $element;
		this.modal = modal;
		this.UrlData = UrlData;
		this.numberOfWordsBeforeAndAfterSearch = 5;
		this.showSearch = false;
		this.pxWidthOfSearchTab = 0;
		this.collapsedWidth = 50;
		this.expandedWidth = 245;
	}

	$onInit() {
		if (this.searchTerm) {
			// since searchTerm is an array of objects, join the words that were actually searched
			this.searchTermWord = this.searchTerm.map(term => term.word).join(' ');
			this.searchLanguage = this.searchTerm[0].language;
		}
	}

	$onChanges(changes) {
		//gets fired the first time the component loads and anytime the attachment changes
		if (changes.attachment) {
			this.loadTranscript();
		}
	}

	loadTranscript() {
		if (VideoPlayerHtml5.isPlayable(this.attachment.streaming_url)) {
			this.Api.get(`/attachments/${this.attachment.id}/transcript`).then(transcriptInfo => {
				if (!transcriptInfo) {
					return;
				}
				this.searchTabCollapsed = true;
				this.pxWidthOfSearchTab = this.collapsedWidth;
				this.showSearch = true;
				this.transcriptInfo = transcriptInfo;
				if (this.searchTerm) {
					this.searchResults = this.searchTranscript(this.searchTerm);
					this.searchTabCollapsed = false;
					this.pxWidthOfSearchTab = this.expandedWidth;
				}
			});
		}
	}

	searchTranscript(wordsWithVariants) {
		let allSearchResults = [];
		wordsWithVariants.forEach(wordWithVariants => {
			allSearchResults.push(this.searchTranscriptForWordVariants(wordWithVariants));
		});
		//flatten Array
		const searchResults = [].concat(...allSearchResults);
		searchResults.sort((a, b) => {
			return a.time - b.time;
		});
		return searchResults;
	}

	handleSearchSubmit() {
		this.Api.get(`/attachments/prizm_search_terms?phrase=${this.searchTermWord}`).then(wordsWithVariants => {
			if (wordsWithVariants) {
				this.searchTerm = wordsWithVariants;
				this.searchResults = this.searchTranscript(wordsWithVariants);
			}
		});
	}
	handleSearchTabClick() {
		if (this.searchTabCollapsed) {
			this.searchTabCollapsed = false;
			this.pxWidthOfSearchTab = this.expandedWidth;
		} else {
			this.searchTabCollapsed = true;
			this.pxWidthOfSearchTab = this.collapsedWidth;
		}
	}

	jumpToTimeInVideo(time) {
		const video = this.$element.find('video')[0];
		if (time - 5 < 0) {
			video.currentTime = 0;
		} else {
			video.currentTime = time - 5;
		}
	}

	searchTranscriptForWordVariants(wordWithVariants) {
		let allSearchResults = [];
		const variants = wordWithVariants.variants;
		variants.forEach(variant => {
			const searchTerm = variant.searchTerm.toLowerCase();

			if (this.isSearchPhrase(variant.searchTerm)) {
				allSearchResults.push(this.searchTranscriptForPhrase(variant));
			} else if (searchTerm in this.transcriptInfo) {
				allSearchResults.push(this.searchTranscriptForWord(variant));
			}
		});
		//flatten Array
		return [].concat(...allSearchResults);
	}

	searchTranscriptForPhrase(variant) {
		const searchTerm = variant.searchTerm.toLowerCase();
		const words = searchTerm.split(' ');
		const indexes = this.transcriptInfo[words[0]];
		let searchResults = [];
		indexes.forEach(index => {
			const stringToSearch = this.getPortionOfTranscriptToSearch(index, words.length);
			//if string to search does not contain search term
			if (stringToSearch.indexOf(searchTerm) === -1) {
				return;
			}

			const indexesOfLastWordInSearchPhrase = this.transcriptInfo[words[words.length - 1]];
			const endingIndex =
				indexesOfLastWordInSearchPhrase[
					indexesOfLastWordInSearchPhrase.findIndex(indexOfLastWord => indexOfLastWord > index)
				];

			const searchResult = {
				wordsBefore: this.getFormattedWordsBeforeIndex(index),
				wordsAfter: this.getFormattedWordsAfterIndex(endingIndex),
				time: parseInt(this.transcriptInfo.timeContentOccurred[index], 10),
				searchTerm: this.transcriptInfo.arrayOfContent
					.slice(index, endingIndex + 1)
					.join(' ')
					.replace(/\s+(\W)/g, '$1'),
				stringTime: this.convertSecondsToTimeString(this.transcriptInfo.timeContentOccurred[index]),
				highlightColor: variant.highlightColor,
			};

			searchResults.push(searchResult);
		});
		return searchResults;
	}

	searchTranscriptForWord(variant) {
		const searchTerm = variant.searchTerm.toLowerCase();
		let searchResults = [];
		const indexes = this.transcriptInfo[searchTerm];
		indexes.forEach(index => {
			const searchResult = {
				wordsBefore: this.getFormattedWordsBeforeIndex(index),
				wordsAfter: this.getFormattedWordsAfterIndex(index),
				searchTerm: this.transcriptInfo.arrayOfContent[index],
				time: parseInt(this.transcriptInfo.timeContentOccurred[index], 10),
				stringTime: this.convertSecondsToTimeString(this.transcriptInfo.timeContentOccurred[index]),
				highlightColor: variant.highlightColor,
			};

			searchResults.push(searchResult);
		});
		return searchResults;
	}

	isSearchPhrase(searchTerm) {
		const searchTermArray = searchTerm.split(' ');
		return searchTermArray.length > 1;
	}

	getPortionOfTranscriptToSearch(index, numberOfWordsInPhrase) {
		let numberOfWordsInSearchString = 0;
		let searchStringArray = [];
		while (numberOfWordsInSearchString < numberOfWordsInPhrase) {
			const content = this.transcriptInfo.arrayOfContent[index];
			//skip over content in transcript if it isn't a word ie (, . ! ?)
			if (/^([a-zA-Z])/.test(content)) {
				searchStringArray.push(content);
				numberOfWordsInSearchString++;
			}
			index++;
		}
		return searchStringArray.join(' ').toLowerCase();
	}

	getFormattedWordsBeforeIndex(index) {
		const contentBefore = this.getContentBeforeIndex(index);
		const formattedTextBeforeSearchTerm = this.removeSpacesBeforePunctuation(contentBefore);
		return formattedTextBeforeSearchTerm;
	}

	getFormattedWordsAfterIndex(index) {
		const contentAfter = this.getContentAfterIndex(index);
		const formattedTextAfterSearchTerm = this.formatTextAfterSearchTerm(contentAfter);
		return formattedTextAfterSearchTerm;
	}

	removeSpacesBeforePunctuation(content) {
		return content.replace(/\s+(\W)/g, '$1');
	}

	formatTextAfterSearchTerm(content) {
		const contentWihFormattedPunctuation = this.removeSpacesBeforePunctuation(content);
		const formattedTextAfterSearchTerm = this.addSpaceIfStartsWithLetter(contentWihFormattedPunctuation);
		return formattedTextAfterSearchTerm;
	}

	addSpaceIfStartsWithLetter(text) {
		if (/^([a-zA-Z])/.test(text)) {
			text = ` ${text}`;
		}
		return text;
	}

	getContentBeforeIndex(index) {
		let numberOfWordsBeforeSearch = 0;
		let contentBefore = [];
		//start at index before search term
		index--;
		while (numberOfWordsBeforeSearch < this.numberOfWordsBeforeAndAfterSearch && index >= 0) {
			const content = this.transcriptInfo.arrayOfContent[index];
			contentBefore.unshift(content);
			//If content is word
			if (/^([a-zA-Z])/.test(content)) {
				numberOfWordsBeforeSearch++;
			}
			index--;
		}
		return contentBefore.join(' ');
	}

	getContentAfterIndex(index) {
		let numberOfWordsAfterSearch = 0;
		let contentBefore = [];
		//start at index after search term
		index++;
		while (
			numberOfWordsAfterSearch < this.numberOfWordsBeforeAndAfterSearch &&
			index <= this.transcriptInfo.arrayOfContent.length - 1
		) {
			const content = this.transcriptInfo.arrayOfContent[index];
			contentBefore.push(content);
			//If content is word
			if (/^([a-zA-Z])/.test(content)) {
				numberOfWordsAfterSearch++;
			}
			index++;
		}
		return contentBefore.join(' ');
	}

	convertSecondsToTimeString(secondString) {
		var totalSeconds = parseInt(secondString, 10);
		var hours = Math.floor(totalSeconds / 3600);
		var minutes = Math.floor((totalSeconds - hours * 3600) / 60);
		var seconds = totalSeconds - hours * 3600 - minutes * 60;
		if (seconds < 10) {
			seconds = `0${seconds}`;
		}
		return hours ? `${hours}:${minutes}:${seconds}` : `${minutes}:${seconds}`;
	}
}
